import "./UserRequestDetails.css";
import { PulseLoader } from "react-spinners";
import React, { Fragment } from "react";
import UserRequestsDetailsViewModel from "./UserRequestDetailsViewModel";

const UserRequestDetails = () => {
  const { RequestDetails, IsLoading } = UserRequestsDetailsViewModel();

  return (
    <Fragment>
      {IsLoading ? (
        <PulseLoader
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          color="#3D5EE1"
          //   size={16}
        />
      ) : (
        <div className="page-wrapper user-request-details-page">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">User Request Details</h3>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-md-12">
                <div className="tab-content profile-tab-cont">
                  <div
                    className="tab-pane fade show active"
                    id="per_details_tab"
                  >
                    <div className="row">
                      <div className="col-lg-9">
                        <div className="card">
                          <div className="card-body">
                            <h5 className="card-title d-flex justify-content-between mb-2">
                              <span>Request Details</span>
                            </h5>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">Name:</p>
                              <p className="dynamic-value">
                                {RequestDetails?.Name}
                              </p>
                            </div>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">
                                Email ID:
                              </p>
                              <p className="dynamic-value">
                                {RequestDetails?.Email}
                              </p>
                            </div>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">Mobile:</p>
                              <p className="dynamic-value">
                                {RequestDetails?.PhoneNo}
                              </p>
                            </div>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">CNIC:</p>
                              <p className="dynamic-value">
                                {RequestDetails?.CNIC}
                              </p>
                            </div>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">
                                School Type:
                              </p>
                              <p className="dynamic-value">
                                {RequestDetails?.SchoolType}
                              </p>
                            </div>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">
                                School Level:
                              </p>
                              <p className="dynamic-value">
                                {RequestDetails?.SchoolLevel}
                              </p>
                            </div>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">
                                No Of Teachers:
                              </p>
                              <p className="dynamic-value">
                                {RequestDetails?.NoOfTeachers}
                              </p>
                            </div>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">
                                No Of Students:
                              </p>
                              <p className="dynamic-value">
                                {RequestDetails?.NoOfStudents}
                              </p>
                            </div>

                            <div className="personal-details-individual-container">
                              <p className="title-for-dynamic-value">
                                Message:
                              </p>
                              <p className="dynamic-value">
                                {RequestDetails?.Message}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default UserRequestDetails;
